export default {
    mounted(el) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        el.classList.add('in');
                        el._revealed = true;
                        observer.unobserve(el);
                    }
                });
            },
            { threshold: 0.1 }
        );
        observer.observe(el);
    },
    updated(el) {
        if (el._revealed) {
            el.classList.add('in');
        }
    }
};
